import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Business facts fallback so the site renders fully even before /api/config answers.
export const FALLBACK_CONFIG = {
  business: {
    name: "Dorothy Read Healing",
    practitioner: "Dorothy Read",
    address_lines: [
      "Wellspring Holistic Center",
      "239 E Brown St, Suite 1",
      "East Stroudsburg, PA 18301",
    ],
    maps_url:
      "https://www.google.com/maps/search/?api=1&query=Wellspring+Holistic+Center%2C+239+E+Brown+St%2C+Suite+1%2C+East+Stroudsburg%2C+PA+18301",
    service_area: "East Stroudsburg, Stroudsburg and the surrounding Pocono area",
    timezone_label: "Eastern Time",
    experience_statement: "over 30 years of experience",
  },
  scheduler: { configured: false, url: "" },
  pricing: {
    session: { label: "Personalized session", minutes: 90, price: 125, note: "One unhurried session - what happens inside it is shaped around you" },
    packages: [
      { sessions: 2, total: 225, note: "Two 90-minute sessions, $112.50 each - a 10% saving per visit" },
      { sessions: 3, total: 300, note: "Three 90-minute sessions, $100 each - a 20% saving per visit" },
    ],
    packages_note: "Each visit added to a package brings the per-visit cost down by 10%. Payment is arranged with Dorothy in person.",
  },
  policies: {
    cancellation: "Please give at least 24 hours' notice if you need to cancel or reschedule.",
    payment: "Payment is arranged with Dorothy in person.",
  },
  disclaimer: "Experiences vary. These services do not replace medical diagnosis, treatment or mental health care.",
};

let cache = null;
let inflight = null;

export function useSiteConfig() {
  const [config, setConfig] = useState(cache || FALLBACK_CONFIG);
  useEffect(() => {
    if (cache) return;
    if (!inflight) {
      inflight = fetch(`${API}/config`).then((r) => (r.ok ? r.json() : Promise.reject()));
    }
    inflight
      .then((data) => {
        cache = data;
        setConfig(data);
      })
      .catch(() => setConfig(FALLBACK_CONFIG));
  }, []);
  return config;
}

// Privacy-safe analytics: button/click events only, never form content.
export function track(event, props = {}) {
  try {
    if (window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(event, props);
    }
  } catch {
    /* analytics must never break the page */
  }
}
